import Vue from 'vue'
import App from './App.vue'

import _ from 'lodash'
import numeral from 'numeral'
import dayjs from 'dayjs'
import Vuelidate from 'vuelidate'
import router from './router/index'
import store from './store/index'
import vuetify from '@/plugins/vuetify'
import { i18n } from '@/plugins/vue-i18n'
import './assets/style/mycss-variables.scss'

Vue.use(Vuelidate)
Vue.config.productionTip = false

Vue.prototype._ = _
Object.defineProperty(Vue.prototype, 'numeral', { value: numeral })
Object.defineProperty(Vue.prototype, '$dayjs', { value: numeral })

new Vue({
  vuetify,
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
